/**
 * @generated SignedSource<<9c345780a05bff89fd5b996fa880b8f7>>
 * @relayHash 6470cfa1be8f9b8c8fcb837d9e2a7113
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b204fa10a424d4c3f4b92bccf1197ee291721538405d55ef4691cb703e693aa4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityPeopleViewContentQuery } from './CapacityPeopleViewContentQuery.graphql';

import isAiImportEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/common/cell/contribution-cell/../../../../../../is-ai-import-enabled.relayprovider';
import isBulkEditEnabled_provider from '../../../../../../../platform/packages/capacity-planning/capacity-planning-core/src/ui/capacity-planning-core/table/people/row/people-view-body-row/../../../../../../is-bulk-edit-enabled.relayprovider';

const node: PreloadableConcreteRequest<CapacityPeopleViewContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b204fa10a424d4c3f4b92bccf1197ee291721538405d55ef4691cb703e693aa4",
    "metadata": {},
    "name": "CapacityPeopleViewContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__isaiimportenabledrelayprovidertsx": isAiImportEnabled_provider,
      "__relay_internal__pv__isbulkeditenabledrelayprovidertsx": isBulkEditEnabled_provider
    }
  }
};

export default node;
